module.exports = __webpack_public_path__ + "static/media/info-icon.f3cc8364.svg";